import React, { ReactElement } from 'react';
import { ForceFocus } from '@mo/accessibility';
import cn from 'classnames';

import styles from './client-error-box.module.scss';
import WarningIcon from './icon/WarningIcon';

export interface PageErrorBoxProps {
    analyticsTag?: string;
    className?: string;
    focus?: () => void;
    removeFocus?: () => void;
}

const ClientErrorBox: React.FunctionComponent<PageErrorBoxProps> = (props): ReactElement | null => {
    return (
        <ForceFocus removeFocus={props.removeFocus} focus={props.focus}>
            <div className={cn(styles.errorBoxContainer, props.className)} data-locator='error-box'>
                <WarningIcon />
                <div>{props.children}</div>
            </div>
        </ForceFocus>
    );
};

export default ClientErrorBox;
